import { render } from "./BrowsePortfolioLists.vue?vue&type=template&id=4dd7516d&scoped=true"
import script from "./BrowsePortfolioLists.vue?vue&type=script&lang=js"
export * from "./BrowsePortfolioLists.vue?vue&type=script&lang=js"

import "./BrowsePortfolioLists.vue?vue&type=style&index=0&id=4dd7516d&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd7516d"]])

export default __exports__